import { createFileRoute } from '@tanstack/react-router';
import { DocumentManager } from '@/pet/src/components/DocumentManager';
import { NoPetsEmptyState } from '@/pet/src/components/NoPetsEmptyState';
import { usePets } from '@/pet/src/context/PetsContext';

export const Route = createFileRoute('/dashboard/documents')({
  component: PetsoDocuments,
});

function PetsoDocuments() {
  const { selectedPet, isLoading } = usePets();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!selectedPet) {
    return (
      <NoPetsEmptyState />
    );
  }

  return <DocumentManager pet={selectedPet} />;
}
